import React, { useRef } from "react";
import { triggerAnalyticsEvent } from "../../../helpers";
import { PhraseKey, Say } from "../../../languages";

type Props = {
  labelClasses?: string;
  labelPhraseKey?: PhraseKey;
  containerClasses?: string;
  inputId?: string;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  visible?: boolean;
};

const SimpleFileInput = ({
  labelClasses = "",
  containerClasses = "",
  labelPhraseKey = "generic.photo.upload_cta",
  inputId = "photo_upload",
  handleFileChange,
  visible = true
}: Props) => {
  const labelRef = useRef<HTMLLabelElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  if (!visible) {
    return null;
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.key === "Enter") {
      inputRef.current?.click();
      reportAnalytics();
    } else if (event.key === " ") {
      event.preventDefault();
      inputRef.current?.click();
      reportAnalytics();
    }
  };

  const reportAnalytics = () => {
    const eventButtonText = labelRef.current?.innerText || "";

    triggerAnalyticsEvent("photo_upload_click", {
      chosen_photo_click: "chosen_photo_retake",
      eventLabel: eventButtonText
    });
  };

  return (
    <div className={containerClasses}>
      <label
        ref={labelRef}
        htmlFor={inputId}
        className={`btn btn-ghost-orange ${labelClasses}`}
        tabIndex={0}
        onKeyDown={handleKeyPress}
        onClick={reportAnalytics}>
        <Say phrase={labelPhraseKey} />
      </label>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg"
        id={inputId}
        className="hidden"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default SimpleFileInput;
